/**
 * HoM Routing Experiments — Landing page router via Statsig layer
 */
(function () {
    'use strict';

    var STATSIG_TIMEOUT_MS = 3000;
    var LAYER_NAME = 'landing_page_router';
    var PAGE_PATH_RE = /^\/pages\/([^\/]+)\/?$/;

    function waitForStatsig(callback) {
        var resolved = false;

        function resolve() {
            if (resolved) return;
            resolved = true;
            callback();
        }

        var timer = setTimeout(function () {
            console.warn('[HoMRoutingExperiments] Statsig timeout');
            resolve();
        }, STATSIG_TIMEOUT_MS);

        (function check() {
            var ready = window.HoMStatsig &&
                window.HoMStatsig.ready === true &&
                window.HoMStatsig.client &&
                typeof window.HoMStatsig.client.getLayer === 'function';

            if (ready) {
                clearTimeout(timer);
                resolve();
            } else {
                setTimeout(check, 50);
            }
        })();
    }

    var match = PAGE_PATH_RE.exec(window.location.pathname);
    if (!match) return;

    var pageKey = match[1].toLowerCase();

    waitForStatsig(function () {
        if (!window.HoMStatsig || !window.HoMStatsig.client) return;

        var layer = window.HoMStatsig.client.getLayer(LAYER_NAME);
        if (!layer) return;

        var targetValue = layer.get(pageKey, '');
        if (!targetValue || typeof targetValue !== 'string') return;

        var target;
        try {
            target = new URL(targetValue, window.location.origin);
        } catch (e) {
            console.warn('[HoMRoutingExperiments] Invalid target URL:', targetValue);
            return;
        }

        target.search = window.location.search;
        target.hash = window.location.hash;

        if (target.href === window.location.href) return;

        window.location.replace(target.href);
    });
})();
